import React from 'react';
import MediaQueries from 'react-responsive';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import MediaThreeColImages from 'marketing-website/components/modules/Media/MediaThreeColImages';

import assets from 'marketing-website/configs/pages/features/wireframing/assets.js';

export default function FeatureWireframing() {
  return (
    <Spacing size="0" sizeM="xl" type="padding" position="topBottom">
      <Spacing size="xl" sizeM="0" position="bottom">
        <MediaQueries maxWidth={769}>
          <MediaThreeColImages
            radius="none"
            background="none"
            fallbackImage={assets.screensFallbackRetina}
            images={assets.experimentBlock}
          />
        </MediaQueries>
        <PageWrap size="l">
          <HeadingBlock
            justifyContent="center"
            justifyM="start"
            title="Drag and drop wireframe templates"
            copy={
              <span>
                We’ve designed hundreds of simple wireframe assets for every
                device, all stored in our intuitive wireframing tool.
                <br />
                <br />
                All the assets are included with Marvel, no add-ons necessary.
                We've taken care of everything, so you can focus on generating
                ideas.
              </span>
            }
            size="xs"
          />
        </PageWrap>
        <MediaQueries minWidth={770}>
          <MediaThreeColImages
            radius="none"
            background="shape"
            fallbackImage={assets.experimentBlock[0]}
            images={assets.experimentBlock}
          />
        </MediaQueries>
      </Spacing>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/features/wireframing/ExperimentBlock.js